<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-left fluid> 
                 <v-layout row wrap>
                        <v-flex xs2 class="mr-3">
                            <v-dialog ref="fromDateDialog" v-model="fromDateModal" :return-value.sync="search.fromDate" persistent lazy full-width width="290px">
                                <v-text-field slot="activator" v-model="search.fromDate" label="From Date" append-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="search.fromDate" scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="fromDateModal = false">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-flex>
                        <v-flex xs2>
                            <v-dialog ref="toDateDialog" v-model="toDateModal" :return-value.sync="search.toDate" persistent lazy full-width width="290px">
                                <v-text-field slot="activator" v-model="search.toDate" label="To Date" append-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="search.toDate" scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="toDateModal = false">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-flex>
                 </v-layout>

                 <v-layout>
                    <v-flex xs6>
                        <v-card>
                            <v-card-title>
                                <v-flex xs8></v-flex>
                                <v-flex xs4>
                                    <v-text-field v-model="searchTable" append-icon="search" label="Search" single-line hide-details></v-text-field>
                                </v-flex>
                            </v-card-title>

                            <v-data-table v-model="selected" id="transactions-volume-table" :headers="tableHeaders" :items="volume" item-key="merchantName" :loading="loading" :search="searchTable" hide-actions class="elevation-1">
                                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                                <template v-slot:items="props">
                                    <td><v-checkbox v-model="props.selected" @change="onCheckboxChange()" primary hide-details></v-checkbox></td>
                                    <td class="text-xs-left">{{ props.item.divisionName }}</td>
                                    <td class="text-xs-left">{{ props.item.merchantName }}</td>
                                    <td class="text-xs-left">£{{ props.item.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg3>
                        <div id="volume-report-summary">
                            <v-card>
                                <v-list class='volume-report-list' dense>
                                    <v-list-tile>
                                        <v-list-tile-content><b>Total:</b></v-list-tile-content>
                                        <v-list-tile-content class="align-end">£{{ new Intl.NumberFormat({ style: 'currency' }).format(total) }}</v-list-tile-content>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-content><b>Merchant Total:</b></v-list-tile-content>
                                        <v-list-tile-content class="align-end">£{{ new Intl.NumberFormat({ style: 'currency' }).format(merchantTotal) }}</v-list-tile-content>
                                    </v-list-tile>
                                </v-list>
                                <v-card-actions>
                                <v-spacer></v-spacer>
                                    <v-btn color="primary" @click="selected = []; merchantTotal = 0;">Clear</v-btn>
                                </v-card-actions>
                            </v-card>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
import axios from 'axios';

export default {
        data() {
            return {
                search: {
                    fromDate: new Date().toISOString().substr(0, 10),
                    toDate: new Date().toISOString().substr(0, 10)
                },
                fromDateModal: false,
                toDateModal: false,
                searchTable: '',
                loading: true,
                volume: [],
                total: null,
                merchantTotal: 0,
                tableHeaders: [{ text: 'Select', sortable: false },
                               { text: 'Division', value: 'divisionName', sortable: true },
                               { text: 'Merchant', value: 'merchantName', sortable: true },
                               { text: 'Amount (£)', value: 'amount', sortable: true }],
                selected: []
            }
        },
        beforeMount() {
           this.getTransactionsValue();
        },
        methods: {
            handleDateChange() {
                if(this.search.toDate < this.search.fromDate) {
                    this.search.fromDate = this.search.toDate;
                }
                this.$refs.fromDateDialog.save(this.search.fromDate);
                this.$refs.toDateDialog.save(this.search.toDate);

                this.loading = true;
                this.getTransactionsValue();
            },
            getTransactionsValue() {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/get-transactions-value',
                data: { search: this.search },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    // console.log(response.data);
                    this.loading = false;
                    this.volume = response.data;
                    
                    this.total = this.volume.reduce(function(p, n) {
                        return p + parseFloat(n.amount);
                    }, 0);

                    let merchants = this.selected.map(m => m.merchantName);
                    let filterMerchants = this.volume.filter(e => e ? merchants.includes(e.merchantName) : null);

                    this.selected = filterMerchants;
                    this.onCheckboxChange();
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            onCheckboxChange() {
                this.merchantTotal = this.selected.reduce(function(p, n) {
                    return p + parseFloat(n.amount);
                }, 0);
            }
        }
}
</script>

<style scoped>
    #transactions-volume-table {
        /* margin-top: 20px; */
        border-top: 1px solid rgba(0,0,0,.12);
    }

    #volume-report-summary {
        position: fixed;
        width: 20%;
    }

    .volume-report-list {
        padding-bottom: 10px;
    }
</style>
